import { getCountryListFetch, getpurByCountryFetch } from "../../api/api";

const state = {
  countryList: [],
  purByCountryList: [],
  purByCountrySummary: {}
}
const actions = {
  async getCountryList({ commit }, { afid, cb }) {
    try {
      const data = await getCountryListFetch({ afid })

      commit('setCountryList', data.countryList);
      cb(data.countryList)
    } catch (e) {
      throw new Error(e)
    }
  },
  async getpurByCountry({ commit }, { param, cb }) {
    try {

      const data = await getpurByCountryFetch({ data: JSON.stringify(param) });
      data.reportResult.map(v => {
        v.size1 = v.totalInstalls1 ? ((v.retention1 / v.totalInstalls1).toFixed(4) * 100).toFixed(2) : "0.00";
        v.size3 = v.totalInstalls3 ? ((v.retention3 / v.totalInstalls3).toFixed(4) * 100).toFixed(2) : "0.00";
        v.size7 = v.totalInstalls7 ? ((v.retention7 / v.totalInstalls7).toFixed(4) * 100).toFixed(2) : "0.00";
        v.size14 = v.totalInstalls14 ? ((v.retention14 / v.totalInstalls14).toFixed(4) * 100).toFixed(2) : "0.00";
        v.size30 = v.totalInstalls30 ? ((v.retention30 / v.totalInstalls30).toFixed(4) * 100).toFixed(2) : "0.00";
      })
      if (data.code === "0000") {
        commit('setpurByCountry', data)
        cb()
      }
    } catch (e) {
      throw new Error(e);
    }
  }
}
const mutations = {
  setCountryList(state, data) {
    state.countryList = data
  },
  setpurByCountry(state, data) {
    state.purByCountryList = data.reportResult,
      state.purByCountrySummary = data.rr
  }
}

export default {
  state,
  actions,
  mutations
}